import React from "react";
import { observer } from "mobx-react";
import { withStyles } from "@material-ui/styles";

import {
  TableContainer,
  Table,
  TableHead,
  TableBody,
  TableCell,
  TableRow,
  Button,
} from "@material-ui/core";
import Paper from "@material-ui/core/Paper";
import user from "../../stores/userStore";
import DeleteIcon from "@material-ui/icons/Delete";
import { toJS } from "mobx";
import { withAlert } from "react-alert";

const styles = (theme) => ({
  tableContainer: {
    marginTop: 20,
  },
  table: {
    minWidth: 650,
  },
  button: {
    margin: 0,
  },
  cardDiv: {
    maxWidth: 500,
  },
  cardBtn: {
    width: "100%",
  },
});

const View = observer(
  class UserList extends React.Component {
    constructor(props) {
      super(props);
      this.state = { btnDelete: false };
    }

    componentDidMount = async () => {
      await user.getUserList();
    };

    DeleteClick = async (userid) => {
      try {
        this.setState({ btnDelete: true });
        if (window.confirm("삭제하시겠습니까?")) {
          await user.deleteUser(userid);
          this.props.alert.show("삭제되었습니다.");
        }
        this.setState({ btnDelete: false });
      } catch (error) {
        this.setState({ btnDelete: false });
      }
    };

    render() {
      const { classes } = this.props;
      const userList = toJS(user.userList).sort(function (a, b) {
        return a.username < b.username ? -1 : a.username > b.username ? 1 : 0;
      });
      const USER = toJS(user.user);
      return (
        <TableContainer component={Paper} className={classes.tableContainer}>
          <Table className={classes.table} aria-label="simple table">
            <TableHead>
              <TableRow>
                <TableCell align="center">ID</TableCell>
                <TableCell align="center">이름</TableCell>
                <TableCell align="center">read</TableCell>
                <TableCell align="center">update</TableCell>
                <TableCell align="center">delete</TableCell>
                {USER.admin == "Y" && (
                  <TableCell align="center">삭제</TableCell>
                )}
              </TableRow>
            </TableHead>
            <TableBody>
              {userList.map((user) => (
                <TableRow key={user._id}>
                  <TableCell align="center">{user.userid}</TableCell>
                  <TableCell align="center">{user.username}</TableCell>
                  <TableCell align="center">{user.read}</TableCell>
                  <TableCell align="center">{user.update}</TableCell>
                  <TableCell align="center">{user.delete}</TableCell>
                  {USER.admin == "Y" && (
                    <TableCell align="center">
                      <Button
                        variant="contained"
                        color="secondary"
                        className={classes.button}
                        startIcon={<DeleteIcon />}
                        disabled={this.state.btnDelete}
                        userid={user.userid}
                        onClick={() => this.DeleteClick(user.userid)}
                      >
                        Delete
                      </Button>
                    </TableCell>
                  )}
                </TableRow>
              ))}
            </TableBody>
          </Table>
        </TableContainer>
      );
    }
  }
);

const alertView = withAlert()(View);
export default withStyles(styles)(alertView);
